import { styled } from "styled-components";

// 문의 안내 사항

export const Inquiryguide = styled.div`
  width: 80%;
  height: 50%;

  border: 2px solid black;

  display: flex;
  align-items: center;
`;
